import {CommonResponse, GetParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {SecurityLogsResponse} from "../models/response"

export const securityLogApi = {
    getSecurityLogs(params?: GetParamsType & SecurityLogFilterQuery): Promise<CommonResponse<SecurityLogsResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`securityLog${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
}

export type SecurityLogFilterQuery = {
    idCompany?: number
    idObjectGroup?: number
    idObject?: number
    idDevice?: number
    idUser?: number
    changeMode?: "MANUAL" | "SCHEDULE" | "DEVICE"
    dateFrom?: string | null | undefined
    dateTo?: string | null | undefined
    search?: string
}